import { produce } from 'immer';
import { useState } from 'react';

import EditableContent from './EditableContent';
import WaitingIcon from './WaitingIcon';

import AccessTimeIcon from '@material-ui/icons/AccessTime';

import ErrorIcon from '@material-ui/icons/Error';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const IconMap = [
  <AccessTimeIcon/>,
  <ErrorIcon style={{color:'red'}}/>,
  <CheckCircleIcon style={{color:'green'}}/>
]

function randIndex(){
  return Math.round(
    Math.random() * 2
  )
}


export default function LabManagementSettings(){

  const [emails,setEmails] = useState(Array(5).fill(""))
  


  return (
    <div class="fair-padding">
      <h4>Lab License Management</h4>


      <div class="sg-row">
        <div class="flex-expand"/>
        <button>Refresh</button>
        <button>Invite</button>
      </div>


      {emails.map((email,iiEmail) => (
        <div class="small-margin sg-row">

          <div style={{
            width:30
            }}
          info="invite-status">
            {IconMap[randIndex()]}
          </div>

          <div>
          {iiEmail+1}. 
          &nbsp;
          </div>
          <input onChange={e => {

            setEmails(produce(emails,draft => {
              draft[iiEmail] = e.target.value;
            }))

          }} value={email}/>
        </div>
      ))}
    </div>
  )
}
